<template>
  <DxPopup
    :visible="visible"
    :show-title="true"
    :title="$t('common.products')"
    :width="'80%'"
    :height="'85%'"
    :hide-on-outside-click="false"
    :drag-enabled="false"
    @hiding="onClose"
  >
    <div style="display: flex; flex-direction: column; height: 95%">
      <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 12px">
        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer">
          <input
            type="radio"
            v-model.number="product_type"
            :value="1"
            @change="$nextTick(() => $refs.fitoFerProductGrid && $refs.fitoFerProductGrid.instance.refresh())"
          />
          <span>{{ $t("products_catalog.fito_products.title") || "Fito" }}</span>
        </label>

        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer">
          <input
            type="radio"
            v-model.number="product_type"
            :value="2"
            @change="$nextTick(() => $refs.fitoFerProductGrid && $refs.fitoFerProductGrid.instance.refresh())"
          />
          <span>{{ $t("products_catalog.fertility_products.title") || "Fertility" }}</span>
        </label>

        <button v-if="emptyAfterSearch" class="btn btn-outline-secondary col-lg-2 add-suggestion-bttn" @click="addProductSuggestion">
          {{ $t("products_catalog.create_suggestion") }}
        </button>
      </div>
      <DxDataGrid
        ref="fitoFerProductGrid"
        class="product_grid"
        :data-source="productsDataSurce"
        :show-borders="true"
        :column-auto-width="true"
        :remote-operations="true"
        :hover-state-enabled="true"
        :show-column-headers="true"
        :repaint-changes-only="true"
        :selected-row-keys="selectedProductUuids"
        @selection-changed="onGridSelectionChanged($event)"
        @row-click="onRowClick"
        :paging="{ pageSize: 25 }"
        :height="'88%'"
      >
        <DxColumn dataField="name" :caption="$t('common.name')" :filter-operations="['contains']" :allowSorting="false" width="25%" />
        <DxColumn
          dataField="category.name"
          :caption="$t('products_catalog.fito_products.category')"
          :filter-operations="['contains']"
          :allowSorting="false"
          width="15%"
          :visible="product_type === 1"
        />
        <DxColumn
          dataField="state.name"
          :caption="$t('common.status')"
          :filter-operations="['contains']"
          :allowSorting="false"
          width="15%"
        />
        <DxColumn
          dataField="classe.name"
          :caption="$t('products_catalog.fito_products.classe')"
          :filter-operations="['contains']"
          :allowSorting="false"
          alignment="center"
          width="15%"
          :visible="product_type === 1"
        />
        <DxColumn
          dataField="product_type.name"
          :caption="$t('common.type')"
          :filter-operations="['contains']"
          :allowSorting="false"
          alignment="center"
          width="15%"
          :visible="product_type === 2"
        />
        <DxColumn
          dataField="updated_at"
          :caption="$t('common.last_update')"
          :filter-operations="['=']"
          :allowSorting="false"
          dataType="date"
          alignment="center"
          width="15%"
          :format="this.getDxGridDefaultDateFormat"
        />
        <DxSelection :mode="multiselect ? 'multiple' : 'single'" showCheckBoxesMode="always" selectAllMode="page" />
        <DxFilterRow :visible="true" />
        <DxGrouping :autoExpandAll="true" />
        <DxGroupPanel :visible="false" />
        <DxPaging :total="3500" :page-size="15" />
        <DxPager
          :visible="true"
          :allowed-page-sizes="pageSizes"
          display-mode="compact"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
          :info-text="$t('common.page_info')"
        />
      </DxDataGrid>
      <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: auto; padding-top: 16px">
        <button class="btn btn-outline-primary col-lg-2 apply-btn" @click="onContinue">{{ $t("common.continue") }}</button>
      </div>
    </div>
    <AddProductSuggestion
      ref="addProductSuggestion"
      v-if="showAddProductSuggestionDialog"
      :visible="showAddProductSuggestionDialog"
      @close="showAddProductSuggestionDialog = false"
      :data="suggestionData"
    />
  </DxPopup>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxPaging,
  DxLookup,
  DxPager,
} from "devextreme-vue/data-grid";
import DxPopup from "devextreme-vue/popup";
import CustomStore from "devextreme/data/custom_store";
import AddProductSuggestion from "@/components/AddProductSuggestion.vue";
import { getDxFilterValueByKey } from "@/helpers/dxGridHelper";

export default {
  name: "FitoFertilityProductSelector",
  components: {
    DxDataGrid,
    DxColumn,
    DxPopup,
    DxSelection,
    DxFilterRow,
    DxGrouping,
    DxGroupPanel,
    DxPaging,
    DxLookup,
    DxPager,
    AddProductSuggestion,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    multiselect: {
      type: Boolean,
      default: () => true,
    },
    selectedProductUuids: {
      type: Array,
      default: () => [],
    },
    filterData: {
      type: Object,
      default: () => ({}),
    },
    productUuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      productsDataSurce: new CustomStore({
        key: "uuid",
        load: async (loadOptions) => {
          let dataSource = {
            data: [],
            totalCount: 0,
          };

          let pageLimit = loadOptions.take;
          let pageNumber = (loadOptions.skip + loadOptions.take) / pageLimit;

          let payload = {
            page: pageNumber,
            limit: pageLimit,
            filter: loadOptions.filter,
            sort: loadOptions.sort,
            with_custom_products: false
          };

          if (this.filterData && Object.keys(this.filterData).length > 0) {
            Object.assign(payload, this.filterData);
          }

          try {
            if (this.product_type === 1) {
              await this.getFitoProducts(payload).then((response) => {
                dataSource.data = response.data;
                dataSource.totalCount = response?.pagination?.total ?? 1;
              });
            } else if (this.product_type === 2) {
              await this.getFertilityProducts(payload).then((response) => {
                dataSource.data = response.data;
                dataSource.totalCount = response?.pagination?.total ?? 1;
              });
            }

            // detect if a filter/search was active
            const filterActive = Boolean(loadOptions.searchValue || (loadOptions.filter && loadOptions.filter.length));
            this.emptyAfterSearch = dataSource.totalCount === 0 && filterActive;
            if (this.emptyAfterSearch) {
              const nameFilter = getDxFilterValueByKey("name", loadOptions.filter);
              this.suggestionData = {
                sm_product_uuid: this.productUuid,
                source_type: this.product_type === 1 ? "FITO" : "FERTILITY",
                name: nameFilter,
              };
            }

            return dataSource;
          } catch (error) {
            console.error("Error fetching products:", error);
            throw error;
          }
        },
      }),
      gridRemoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
      pageSizes: [15, 25, 100],
      localSelectedProductUuids: [...this.selectedProductUuids],
      product_type: 1, // 1 - Fito, 2 - Fertility
      // new reactive flags
      emptyAfterSearch: false,
      showAddProductSuggestionDialog: false,
      suggestionData: {},
    };
  },
  computed: {
    ...mapGetters({
      getDxGridDefaultDateFormat: "settings/getDxGridDefaultDateFormat",
    }),
  },
  watch: {
    selectedProductUuids: {
      deep: true,
      handler(newData) {
        this.localSelectedProductUuids = [...newData];
        this.$refs.fitoFerProductGrid.instance.selectRows(newData, false);
      },
    },
  },
  methods: {
    ...mapActions({
      getFitoProducts: "fitoProduct/getFitoProducts",
      getFertilityProducts: "fertilityProduct/getFertilityProducts",
    }),
    onClose() {
      this.$emit("close");
    },
    onContinue() {
      const selectedRows = this.$refs.fitoFerProductGrid.instance.getSelectedRowsData();
      this.$emit("continue", selectedRows ?? []); // Emit the selected products to the parent component

      this.$refs.fitoFerProductGrid.instance.clearSelection();
      this.localSelectedProductUuids = [];
      this.$emit("update:selectedProductUuids", []);
    },
    onGridSelectionChanged(e) {},
    onRowClick(e) {
      // Prevent default behavior if the row is already selected and multiselect is false
      if (!this.multiselect) {
        return;
      }

      const rowKey = e.key; // Get the unique key of the clicked row
      const selectedIndex = this.selectedProductUuids.indexOf(rowKey);

      if (selectedIndex === -1) {
        // If the row is not selected, add it to the selection
        this.selectedProductUuids.push(rowKey);
      } else {
        // If the row is already selected, remove it from the selection
        this.selectedProductUuids.splice(selectedIndex, 1);
      }

      // Update the grid's selected rows
      this.$refs.fitoFerProductGrid.instance.selectRows(this.selectedProductUuids, false);
    },
    addProductSuggestion() {
      this.showAddProductSuggestionDialog = true;
    },
  },
  mounted() {},
};
</script>
<style scoped>
.add-suggestion-bttn {
  margin-left: 50px;
}
</style>
